module.exports = __webpack_public_path__ + "img/auth1.5ab2540b.png";